import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    dataCrud: [],
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    dataCrud(state) {
      return state.dataCrud;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertDataCrud(state, dataCrud) {
      state.dataCrud = dataCrud;
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proPatientsBSchema();
        const schema = res.data;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadDataCrud({ commit }, payload) {
      try {
        const id = getInstProfesId();

        let model = {};
        if (payload === undefined) {
          model.usersPin = false;
        } else {
          const usersPin = payload.usersPin;
          model.usersPin = usersPin;
        }

        const res = await apiClient.dataCrudProPatientsB(id, model);
        const dataCrud = res.data.data;
        commit('insertDataCrud', dataCrud);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
  },
};
